import { useAuth } from '../hooks/useAuth.js';
import DocumentsList from '../components/docs/DocumentsList.jsx';

export default function DocumentsPage() {
  const { user, isAdmin } = useAuth();
  return <DocumentsList target={user.discord_id} title="My documents" isAdmin={isAdmin} />;
}
